import { GridAction } from "@ctsu/ctsu-mui-grid";
import { OpenErrorNotification, OpenSuccessNotification } from "@ctsu/react-ctsu-ui";
import { DatePickerWithModal } from "components/common/Calender";
import { FormikSelect } from "components/common/FormFields/FormikSelect";
import { text } from "components/common/Text";
import { format } from "date-fns";
import { Field, Formik } from "formik";
import makeAjaxRequest from "helpers/makeAjaxRequest";
import React from "react";

import { rootUrl } from "stores/redux/actions/constants";
import { openConfirmAlert } from "@ctsu/react-ctsu-ui";
import { useDispatch } from "react-redux";
import { fetchManageCommittee } from "stores/redux/slice/manageCommitte";

export function validateForm(values) {
  let errors = {};
  let allFieldsFailed = true;

  if (!values.esysId) {
    errors.esysId = "Association is required.";
  } else if (values.esysId.length > 30) {
    errors.esysId = "Association input is too long. Maximum allowed length is 30 characters.";
  } else {
    allFieldsFailed = false;
  }
  if (!values.owner) {
    errors.owner = "Owner is required.";
  } else {
    allFieldsFailed = false;
  }
  if (!values.objectType) {
    errors.objectType = "Object Type is required.";
  } else {
    allFieldsFailed = false;
  }
  if (!values.esysStatus) {
    errors.esysStatus = "Status is required.";
  } else {
    allFieldsFailed = false;
  }
  if (allFieldsFailed) {
    errors = {};
    errors.combinedMessage =
      'The Association, Object Type and Owner must be entered to save the record.'
  }

  return errors;
}

export function submitManageCommittees(data, setIsSubmitting, onSucessCallback) {
  setIsSubmitting(true);
  makeAjaxRequest.putWithAuth(`${rootUrl}/admin/managecommittee`, {
    "comments": data.comments,
    "description": data.description,
    "esysId": data.esysId,
    "esysStatus": data.esysStatus,
    "id": data.id,
    "objectType": data.objectType,
    "owner": data.owner,
    "statusDate": data.statusDate
  }).then(() => {
    onSucessCallback(data);
    setIsSubmitting(false);
    OpenSuccessNotification({
      message: data?.rosterConfigId ? text("api.on_updating_record") : text("api.on_success_msg"),
      autoHide: true
    });
  }).catch((e) => {
    let message = e.message;
    if (e && e.message && e.message.includes("Duplicate record found")) {
      message = "Manage Committees Record already exists.";
    }
    OpenErrorNotification({
      message,
      autoHide: true
    });
  });
}



export default function EditRow({ row, setEditing, rosterOwner, objectTypeLov, esysStatusLov }) {
  const today = new Date();
  const formattedDate = format(today, "dd-MMM-yyyy");
  const dispatch = useDispatch();

  const onSuccessCallback = (params) => dispatch(fetchManageCommittee(params));


  return (
    <Formik
      initialValues={{
        id: row?.id || "",
        esysId: row?.esysId || "",
        objectType: row?.objectType || "",
        owner: row?.owner || "",
        description: row?.description || "",
        esysStatus: row?.esysStatus || "ACTIVE",
        statusDate: row?.statusDate || formattedDate,
        comments: row?.comments || ""
      }}
      onSubmit={(values, actions) => {
        setTimeout(() => {
          alert(JSON.stringify(values, null, 2));
          actions.setSubmitting(false);
        }, 1000);
      }}
    >
      {props => (
        <tr>
          <td>
            <label className="invisible" htmlFor="rosterCode">
              esysId
            </label>
            <div className="form-layout-wrapper bg-transparent position-relative">
              <div className="form-input-wrapper">
                <Field
                  {...{ props }}
                  name="esysId"
                  id="esysId"
                  edit={true}
                />
              </div>
            </div>
          </td>
          <td>
            <label className="invisible" htmlFor="objectType">
              objectType
            </label>
            <div className="form-layout-wrapper bg-transparent position-relative">
              <div className="form-input-wrapper">
                <Field
                  {...{ props }}
                  name="objectType"
                  id="objectType"
                  component={FormikSelect}
                  edit={true}
                  options={[{ label: '', value: '' }, ...objectTypeLov]}
                />
              </div>
            </div>
          </td>
          <td>
            <label className="invisible" htmlFor="owner">
              owner
            </label>
            <div className="form-layout-wrapper bg-transparent position-relative">
              <div className="form-input-wrapper">
                <Field
                  {...{ props }}
                  name="owner"
                  id="owner"
                  component={FormikSelect}
                  edit={true}
                  options={rosterOwner}
                />
              </div>
            </div>
          </td>
          <td>
            <label className="invisible" htmlFor="description">
              description
            </label>
            <div className="form-layout-wrapper bg-transparent position-relative">
              <div className="form-input-wrapper">
                <Field {...{ props }} name="description" id="description" />
              </div>
            </div>
          </td>
          <td>
            <label className="invisible" htmlFor="esysStatus">
              esysStatus
            </label>
            <div className="form-layout-wrapper bg-transparent position-relative">
              <div className="form-input-wrapper">
                <Field
                  {...{ props }}
                  name="esysStatus"
                  id="esysStatus"
                  component={FormikSelect}
                  edit={true}
                  options={esysStatusLov}
                  onChange={(option) => {
                    // if value change from original value, set status date to current date
                    if (option.value !== row?.esysStatus) {
                      props.setFieldValue("statusDate", formattedDate);
                    } else {
                      props.setFieldValue("statusDate", row?.statusDate);
                    }
                  }}
                />
              </div>
            </div>
          </td>
          <td>
            <label className="invisible" htmlFor="statusDate">
              statusDate
            </label>
            <div className="form-layout-wrapper bg-transparent position-relative">
              <div className="form-input-wrapper">
                <Field
                  {...{ props }}
                  name="statusDate"
                  id="statusDate"
                  as={DatePickerWithModal}
                  onChange={props.setFieldValue}
                />
              </div>
            </div>
          </td>
          <td>
            <label className="invisible" htmlFor="comments">
              comments
            </label>
            <div className="form-layout-wrapper bg-transparent position-relative">
              <div className="form-input-wrapper">
                <Field
                  {...{ props }}
                  name="comments"
                  id="comments"
                  edit={true}
                />
              </div>
            </div>
          </td>

          <td>
            <GridAction
              save={() => {
                const errors = validateForm(props.values);
                if (errors && Object.keys(errors).length > 0) {
                  const errorMessage = Object.values(errors).join(" "); // Joining error messages
                  OpenErrorNotification({
                    message: errorMessage,
                    autoHide: true
                  });
                } else {
                  if (props.values.esysStatus === "INACTIVE" && row?.esysStatus === "ACTIVE") {
                    openConfirmAlert({
                      title: "Confirm Inactivation",
                      message: "Person committee records will automatically be set to inactive. Click Yes to proceed.",
                      buttons: [
                        {
                          label: "Yes",
                          onClick: () => submitManageCommittees(props.values, setEditing, onSuccessCallback)
                        },
                        {
                          label: "Cancel",
                          onClick: () => console.log("")
                        }
                      ]
                    });
                  } else {
                    submitManageCommittees(props.values, setEditing, onSuccessCallback);

                  }

                }
              }}
              cancel={() => setEditing(false)}
            />
          </td>
        </tr>
      )}
    </Formik>
  );
}
